import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CommonThreadLocalClass;
function CommonThreadLocal() {
  if (CommonThreadLocalClass === VOID) {
    class $ {
      constructor() {
        this.y13_1 = null;
      }
      z13() {
        return this.y13_1;
      }
      a14(value) {
        this.y13_1 = value;
      }
    }
    initMetadataForClass($, 'CommonThreadLocal', CommonThreadLocal);
    CommonThreadLocalClass = $;
  }
  return CommonThreadLocalClass;
}
function commonThreadLocal(name) {
  return new (CommonThreadLocal())();
}
//region block: exports
export {
  commonThreadLocal as commonThreadLocal18t70xomalc6z,
};
//endregion

//# sourceMappingURL=ThreadLocal.mjs.map
